module.exports = __webpack_public_path__ + "media/images/product/bg3-b950df3361f66d86bcae7dce9c663e3e.png";